import { AVAILABLE_LOCALES } from "@ubisolutions/base";

export const localesProvider = {
    provide: AVAILABLE_LOCALES,
    useValue: [
        "fr-FR",
        "en-US",
        "es-ES",
        "it-IT",
        // "de-DE",
    ],
};
